{
  "ru": {
    "appSwitchButton": {
      "avia": "Авиа",
      "railways": "Ж/Д",
      "tours": "Туры"
    }
  },
  "kk": {
    "appSwitchButton": {
      "avia": "Әуе",
      "railways": "Т/Ж",
      "tours": "Турлар"
    }
  },
  "en": {
    "appSwitchButton": {
      "avia": "Avia",
      "railways": "Railways",
      "tours": "Tours"
    }
  }
}
